import AppStore from "@stores/AppStore";
import CompareMaterialsStore from "@stores/CompareMaterialsStore";
import ScopesStore from "@stores/ScopesStore";
import UserPermissionStore from "@stores/UserPermissionStore";
import { QueryCache, QueryClient } from "@tanstack/react-query";
import { createGlobalState } from "react-hooks-global-state";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
      retry: false,
    },
  },
});

export const queryCache = new QueryCache();

const initialState = {
  appStore: new AppStore(queryClient, queryCache),
  scopeStore: new ScopesStore(),
  upStore: new UserPermissionStore(),
  compareMaterialsStore: new CompareMaterialsStore(),
  /** Mirrors SceneManager.treeVersion; updated via callback so React consumers re-render (sceneManager is not observable). */
  sceneTreeVersion: 0,
};

const { useGlobalState, setGlobalState } = createGlobalState(initialState);
export { useGlobalState };

initialState.appStore.sceneManager.setOnTreeVersionChange(() => {
  setGlobalState("sceneTreeVersion", (v: number) => v + 1);
});
